export default __webpack_public_path__ + "static/data-management-dark-mode-ba0abe5a012b5d90fcabbb8a54a7310f.png";